export const stringifyObjectValues = (obj: object): Record<string, string> => {
  const result: Record<string, string> = {};
  Object.entries(obj).map(([key, value]) => {
    result[key] = value.toString();
  });
  return result;
};
